// extracted by mini-css-extract-plugin
export default {"accordionDetails":"accordion_accordionDetails__SfpHj"};